import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { DateUtils } from "~app/common/utils/date-utils";
import { SetPeriodsattPeriodCommand } from "~app/features/planera/commands/SetPeriodsattPeriodCommand";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { ArbetsorderDisabledFlag } from "../planera-detail/planera-detail-models";
import { ArbetsorderPeriodsattPeriodTexts } from "./arbetsorder-periodsatt-period.texts";

@Component({
    selector: "rask-arbetsorder-periodsatt-period",
    templateUrl: "./arbetsorder-periodsatt-period.component.html",
    styleUrls: ["./arbetsorder-periodsatt-period.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        DatepickerComponent
    ]
})
export class ArbetsorderPeriodsattPeriodComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() arbetsorder: IArbetsorderDetail;
    form: UntypedFormGroup;
    periodsattPeriod: string;
    periodsattPeriodMinDate: string;
    texts = ArbetsorderPeriodsattPeriodTexts.texts;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly formBuilder = inject(UntypedFormBuilder);

    constructor() {
        this.periodsattPeriodMinDate = DateUtils.getStartOfMonth();
    }

    get canSetPeriod(): boolean {
        if (!this.authenticationService.canEdit()) {
            return false;
        }

        if (!this.arbetsorder) {
            return false;
        }

        if (this.arbetsorder.operationer.length && !this.arbetsorder.periodsattPeriod) {
            return false;
        }

        return this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad);
    }

    ngAfterViewInit(): void {
        this.form.get("periodsattPeriod").setValue(this.arbetsorder.periodsattPeriod);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.arbetsorder) {
            return;
        }

        if (changes.arbetsorder.previousValue?.rowVersion !== changes.arbetsorder.currentValue?.rowVersion) {
            this.arbetsorder = changes.arbetsorder.currentValue;
            this.periodsattPeriod = this.arbetsorder.periodsattPeriod;
        }
    }

    ngOnInit(): void {
        if (this.arbetsorder.periodsattPeriod) {
            this.periodsattPeriod = this.arbetsorder.periodsattPeriod;
        }

        this.createForm();
    }

    periodsattPeriodChanged($event: any): void {
        if ($event instanceof Object) {
            return;
        }

        this.periodsattPeriod = $event as string;

        this.arbetsorder.commandManager.addOrUpdate(new SetPeriodsattPeriodCommand(c => {
            c.arbetsorderId = this.arbetsorder.id;
            c.periodsattPeriod = this.periodsattPeriod;
        }), c => c.$type === SetPeriodsattPeriodCommand.$type);
    }

    private createForm(): void {
        this.form = this.formBuilder.group({
            periodsattPeriod: this.formBuilder.control(this.periodsattPeriod)
        });

        this.form.markAsPristine();
    }
}
